import actions from './actions'
import { state } from './state'
import { getters } from './getters'
import { mutations } from './mutations'
import {Module} from 'vuex'

const globalModule: Module<any, any> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

export default globalModule